import React, { useState } from 'react';
import { HiOutlinePlus, HiOutlineTrash } from 'react-icons/hi2';

const WorkPermitStep7GasTests = ({ formData, handleArrayChange }) => {
  const gasTests = JSON.parse(formData.gasTestsJson || '[]');
  const [newTest, setNewTest] = useState({ testType: '', testLocation: '', testResult: '', validUntil: '' });

  const addTest = () => {
    if (!newTest.testType) return;
    handleArrayChange('gasTestsJson', [...gasTests, { ...newTest }]);
    setNewTest({ testType: '', testLocation: '', testResult: '', validUntil: '' });
  };

  const removeTest = (idx) => {
    const copy = [...gasTests];
    copy.splice(idx, 1);
    handleArrayChange('gasTestsJson', copy);
  };

  return (
    <div className="work-permit-step">
      <h3 className="form-section-title">7. Gas Tests</h3>
      <div className="array-field-container">
        {gasTests.length === 0 && <p>No gas tests recorded.</p>}
        {gasTests.map((gt, idx) => (
          <div key={idx} className="form-row">
            <div className='form-group'>
            <input
              type="text"
              value={gt.testType}
              onChange={(e) => {
                const copy = [...gasTests];
                copy[idx].testType = e.target.value;
                handleArrayChange('gasTestsJson', copy);
              }}
              placeholder="Test type (LEL, O2, H2S)"
            />
            </div>
            <div className='form-group'>
            <input
              type="text"
              value={gt.testLocation}
              onChange={(e) => {
                const copy = [...gasTests];
                copy[idx].testLocation = e.target.value;
                handleArrayChange('gasTestsJson', copy);
              }}
              placeholder="Location"
            />
            </div>
            <div className='form-group'>
            <input
              type="text"
              value={gt.testResult}
              onChange={(e) => {
                const copy = [...gasTests];
                copy[idx].testResult = e.target.value;
                handleArrayChange('gasTestsJson', copy);
              }}
              placeholder="Result / readings"
            />
            </div>
            <div className='form-group'>
            <input
              type="datetime-local"
              value={gt.validUntil || ''}
              onChange={(e) => {
                const copy = [...gasTests];
                copy[idx].validUntil = e.target.value;
                handleArrayChange('gasTestsJson', copy);
              }}
            />
            </div>
            <button type="button" className="btn-icon-delete wd50size" onClick={() => removeTest(idx)}>
              <HiOutlineTrash />
            </button>
          </div>
        ))}
        <div className="form-row">
          <div className='form-group'>
          <input
            type="text"
            value={newTest.testType}
            onChange={(e) => setNewTest((prev) => ({ ...prev, testType: e.target.value }))}
            placeholder="Test type"
          />
          </div>
          <div className='form-group'>
          <input
            type="text"
            value={newTest.testLocation}
            onChange={(e) => setNewTest((prev) => ({ ...prev, testLocation: e.target.value }))}
            placeholder="Location"
          />
          </div>
          <div className='form-group'>
          <input
            type="text"
            value={newTest.testResult}
            onChange={(e) => setNewTest((prev) => ({ ...prev, testResult: e.target.value }))}
            placeholder="Result"
          />
          </div>
          <div className='form-group'>
          <input
            type="datetime-local"
            value={newTest.validUntil}
            onChange={(e) => setNewTest((prev) => ({ ...prev, validUntil: e.target.value }))}
          />
          </div>
          <button type="button" className="btn-primary wd50size" onClick={addTest}>
            <HiOutlinePlus />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkPermitStep7GasTests;

